import { useState } from 'react';

import { useSnackbar } from 'notistack';

import ConfirmationDialog from '../../../components/ConfirmationDialog';
import InlineButton from '../../../components/InlineButton';
import { SwimmingLessonProvider } from '../../../types';
import SwimmingLessonProviderRepository from '../repository/SwimmingLessonProviderRepository';

interface DeactivateSLPButtonProps {
  swimmingLessonProvider: SwimmingLessonProvider;
  onSuccess: () => void;
}

const DeactivateSLPButton = (props: DeactivateSLPButtonProps) => {
  const notifications = useSnackbar();

  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    useState<boolean>(false);

  const openConfirmationDialog = () => {
    setConfirmationDialogOpen(true);
  };

  const closeConfirmationDialog = () => {
    setConfirmationDialogOpen(false);
  };

  const deactivateSwimmingLessonProvider = () => {
    new SwimmingLessonProviderRepository()
      .deactivate(props.swimmingLessonProvider.id)
      .then(() => {
        notifications.enqueueSnackbar(
          'De zwemlesaanbieder is succesvol gedeactiveerd',
          {
            variant: 'success',
          },
        );
        props.onSuccess();
      })
      .catch(() => {
        notifications.enqueueSnackbar(
          'Er is iets fout gegaan bij het deactiveren van de zwemlesaanbieder',
          {
            variant: 'error',
          },
        );
      })
      .finally(() => closeConfirmationDialog());
  };

  return (
    <>
      <InlineButton type="dangerous" onClick={openConfirmationDialog}>
        Deactiveren
      </InlineButton>
      <ConfirmationDialog
        title="Deactiveren"
        query="Weet je zeker dat je deze zwemlesaanbieder wilt deactiveren?"
        buttonText="Bevestigen"
        isOpen={confirmationDialogOpen}
        onClose={closeConfirmationDialog}
        onConfirm={() => deactivateSwimmingLessonProvider()}
      />
    </>
  );
};

export default DeactivateSLPButton;
